import {
	BulkDeleteRecordsRequest,
	BulkUpdateRecordsRequest,
	CustomView,
	CustomViewResponse,
	CustomViewsMetadata,
	ListPagePostRequest
} from "@/Contracts/UI/index";
import axios, { AxiosResponse } from "axios";

import {
	getRequest,
	postRequest,
	putRequest,
	deleteRequest
} from "@/Utils/Service/BackendService";

import { ZomentumEntities } from "@/Contracts";
import { ClientContactsResponse } from "@/Contracts/Contacts";
import { includeChildEntities } from "@/Contracts/Utils";

const getContactListPostURL = "/v2/client/users/view";
const getAllContactViewURL = "/v2/views?entity_type={entity_type}";
const getContactViewMetadataURL =
	"/v2/views/metadata?entity_type={entity_type}";
const createContactViewURL = "/v2/views";
const updateContactViewURL = "/v2/views/{view_id}";
const deleteContactViewURL = "/v2/views/{view_id}";
const bulkActionURL = "/v2/async/operation";

export const getContactListPost = async (
	contactRequest: ListPagePostRequest
): Promise<ClientContactsResponse> => {
	try {
		const includedChildEntities = includeChildEntities(
			contactRequest.included_child_entities
		);

		const response: AxiosResponse<ClientContactsResponse> = await axios(
			postRequest(
				getContactListPostURL + `?${includedChildEntities}`,
				contactRequest,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const getContactViewMetadata =
	async (): Promise<CustomViewsMetadata> => {
		try {
			const response: AxiosResponse<CustomViewsMetadata> = await axios(
				getRequest(
					getContactViewMetadataURL.replace(
						"{entity_type}",
						ZomentumEntities.ClientContact
					),
					null,
					true,
					false,
					false
				)
			);
			return response.data;
		} catch (error) {
			console.error(error);
			return Promise.reject(error);
		}
	};

export const getAllContactViews = async (): Promise<CustomViewResponse> => {
	try {
		const response: AxiosResponse<CustomViewResponse> = await axios(
			getRequest(
				getAllContactViewURL.replace(
					"{entity_type}",
					ZomentumEntities.ClientContact
				),
				null,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const createContactView = async (
	customViewRequest: CustomView
): Promise<CustomView> => {
	try {
		const response: AxiosResponse<CustomView> = await axios(
			postRequest(
				createContactViewURL,
				customViewRequest,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const updateContactView = async (
	customViewRequest: CustomView
): Promise<CustomView> => {
	try {
		const response: AxiosResponse<CustomView> = await axios(
			putRequest(
				updateContactViewURL.replace("{view_id}", customViewRequest.id),
				customViewRequest,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const deleteContactView = async (
	customViewId: string
): Promise<unknown> => {
	try {
		const response: AxiosResponse<unknown> = await axios(
			deleteRequest(
				deleteContactViewURL.replace("{view_id}", customViewId),
				null,
				true,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const bulkDeleteContacts = async (
	bulkDeleteRecordsRequest: BulkDeleteRecordsRequest
): Promise<unknown> => {
	try {
		const response: AxiosResponse<unknown> = await axios(
			postRequest(
				bulkActionURL,
				bulkDeleteRecordsRequest,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const bulkUpdateContacts = async (
	bulkUpdateRecordsRequest: BulkUpdateRecordsRequest
): Promise<unknown> => {
	try {
		const response: AxiosResponse<unknown> = await axios(
			postRequest(
				bulkActionURL,
				bulkUpdateRecordsRequest,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};
